import type { FC } from 'react';

import UnavailableIcon from 'static/images/unavailable-content.svg';

import { unavailableContentLabel } from '../constants';
import { useUnavailableContent } from '../hooks/useUnavailableContent';
import { unavailableContent } from './constants';
import styles from './styles.module.scss';

const Body: FC = () => {
    const { unavailableContentType } = useUnavailableContent();
    const content = unavailableContentType ? unavailableContent[unavailableContentType] : null;

    return (
        <div className={styles.wrapper}>
            <img src={UnavailableIcon} alt={unavailableContentLabel} />
            <span className={styles.text}>{content}</span>
        </div>
    );
};

export default Body;
